// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"caf944e1","215":"ca8ff1a3","424":"4155548e","879":"18b98cae","963":"22e36694"}[chunkId] + ".chunk.js";
};